import Container from "./container";
import React, { useLayoutEffect } from "react";
import { cn } from "../lib/helpers";
import { gsap } from 'gsap';
import Icon from "./icon";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import Links from "./links";
import Demo from "./demo"

import * as styles from "../styles/components/page-header.module.css";

const PageHeader = (props) => {
  const {
    title,
    subtitle,
    description,
    button,
    link,
    image,
    bookDemoForm,
    hideButton,
    hideLink
  } = props;

  useLayoutEffect(() => {
    const svgs = gsap.utils.toArray(".dots-header-img-wrapper svg");

    svgs.forEach(function(svg) {
  
      const paths = svg.querySelectorAll("path");

      paths.forEach(function(path, i) {
        gsap.to(path, {
          opacity: 1,
          ease: "none",
        }).delay(i*0.05);
      });
    });
  });

  return (
    <div className={cn(styles.root, styles.dark)}>
      <Container>
        <div className="grid">
          <div className="col-12 col-md-6">
            <div className="content-sm">
              {subtitle && <div className={cn("h6", styles.subtitle)}>{subtitle}</div>}
              {title && <h1 className={cn("h3", styles.title)}>{title}</h1>}
              {description && <p>{description}</p>}
              {((button && button.url ) || (link && link.url)) &&
                <Links button={!hideButton ? button : null} link={!hideLink ? link : null} dark="true" />
              }
              {bookDemoForm && <Demo dark={true}/>}
            </div>
          </div>
          <div className={cn("col-12 col-md-6", styles.image)}>
            {image && image.asset &&
              <img
                src={imageUrlFor(buildImageObj(image))
                  .auto("format")
                  .url()}
                alt={image.alt}
              />
            }
          </div>
        </div>
        <div className={cn("dots-header-img-wrapper", styles.dotsHeaderImgWrapper)}>
          <div className="m-hide"><Icon symbol="dots-header-img" /></div>
          <div className="d-hide"><Icon symbol="dots-header-img-m" /></div>
        </div>
      </Container>
    </div>
  );
}

export default PageHeader;
